import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentDynamicPredecisionGet = {
    path: "/consent/dynamic-predecision",
    method: RouteHttpVerb.POST,
    obfuscatePath: "keep-last-part"
};
export { locationRestConsentDynamicPredecisionGet };
